// [init]

import moment from 'moment';


export default {


	namespaced: true,

	state: {
		// Listing of all cleaners ( Array )
		cleanersList: [],

		// Listing of all cleaners suggest ( Array )
		cleanerSuggestList: [],

		// Current Cleaner being manipulated ( viewed or edited ) ( Object )
		status: '',
		activeCleaner: {}
	},

	mutations: {

		// Update cleanerList with new list
		// @params: Array
		updateCleanerList( state, newList ) {
			state.cleanersList = newList;
		},

		// Update cleanerSuggestList with new list
		// @params: Array
		updateCleanerSuggestList( state, newList ) {
			state.cleanerSuggestList = newList;
		},

		// Add a cleaner into cleanerList
		addCleaner( state, newCleaner ) {
			state.cleanersList.push( newCleaner );
		},

		// Delete a cleaner from cleanerList
		// @params: identifier (String)
		deleteCleaner( state, identifier ) {
			state.cleanersList = state.cleanersList.filter(cleaner => {
				return cleaner.id != identifier;
			});
		},

		// Update the current active Cleaner object
		// @params: newActiveCleaner (Object)
		updateActiveCleaner( state, newActiveCleaner ) {
			state.activeCleaner = newActiveCleaner;
		},

		// Change status of cleanerForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activeCleaner = {};
		}

	},

	actions: {
		
		/* 
		*  /GET cleaners API
		*  Get all cleaners from the server
		*  @return: Array
		*/
		getCleaners( { commit, state }, gender = null ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/cleaners',
					params: {
						trash: this.state.auth.type == 'admin' ? '*' : '0',
						from: 0,
						size: 9999999,
						gender: gender
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateCleanerList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET cleaners suggest API
		*  Get cleaners suggest for customer from the server
		*  @return: Array
		*/
		getCleanersSuggest( { commit, state }, params ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/cleaners/suggest',
					validateStatus: ( status ) => { return status == 200; },
					params: params
				})
				.then(response => {
					commit( 'updateCleanerSuggestList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id cleaners API
		*  Get a single cleaner from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleCleaner( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/cleaners/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateActiveCleaner', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET cleaners API
		*  Get all available cleaners based on location and start times from the server
		*  @return: Array
		*/
		getAvailableTimePackage( { commit, state }, params ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'get',
					url: '/cleaners/list-available',
					validateStatus: ( status ) => { return status == 200; },
					params: params
				})
				.then(response => {
					commit( 'updateCleanerList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET cleaners API
		*  Get all unavailable cleaners
		*  @return: Array
		*/
		getUnavailableDatePackage( { commit, state }, params ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'get',
					url: '/cleaners/list-unavailable-date',
					validateStatus: ( status ) => { return status == 200; },
					params: params
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
    *  /GET cleaners API
    *  Get all unavailable cleaners by month
    *  @return: Array
    */
    getUnavailableDatePackageByMonth( { commit, state }, params ) {

      return new Promise ( (resolve, reject) => {

        global.axios.request({
          method: 'get',
          url: '/cleaners/list-unavailable-date-by-month',
          validateStatus: ( status ) => { return status == 200; },
          params: params
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

		/* 
		*  /GET available time of cleaner API
		*  Get all available time of cleaner based on package and start times from the server
		*  @return: Array
		*/
		getAvailableTime( { commit, state }, params ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'get',
					url: '/cleaners/list-time-available',
					validateStatus: ( status ) => { return status == 200; },
					params: params
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET get regions API
		*  @return: Array
		*/
		getRegions( { commit, state } ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'get',
					url: '/regions',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET get regions cleaner API
		*  @return: Array
		*/
		getRegionsCleaner( { commit, state }, params ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'get',
					url: '/cleaner_regions',
					validateStatus: ( status ) => { return status == 200; },
					params: params
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST updateRegionCleaner API
		*  @return: Array
		*/
		updateRegionCleaner( { commit, state }, data ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'post',
					url: '/cleaner_regions',
					validateStatus: ( status ) => { return status == 200; },
					data: data
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST cleaners API
		*  Add a new cleaner to the server
		*  @params: Object (cleaners data)
		*  @return: Object
		*/
		addCleaner( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				let unavailableDatesHolder;
				if (data.unavailableDates) {
                    unavailableDatesHolder = data.unavailableDates.map(item => {
                    	if(moment(item.startTime).isValid()) {
                            return {
                                startTime: moment(item.startTime).format('YYYY-MM-DD HH:mm:ss'),
                                endTime: moment(item.endTime).format('YYYY-MM-DD HH:mm:ss'),
                                description: item.description
                            };
                        } else if (item.startTime.indexOf('/') != -1) {
                            return {
                                startTime: moment(item.startTime, 'DD/MM/YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
                                endTime: moment(item.endTime, 'DD/MM/YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
                                description: item.description
                            };
                        } else {
                            return {
                                startTime: moment(item.startTime, 'DD-MM-YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
                                endTime: moment(item.endTime, 'DD-MM-YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
                                description: item.description
                            };
                        }
					});
				};

				const postData = {
					salutation: data.salutation,
					firstname: data.firstname,
					lastname: data.lastname,
					profilePhoto: data.profilePhoto,
					email: data.email,
					mobile: '65' + data.mobile,
					languages: data.languages,
					addressLine1: data.addressLine1,
					addressLine2: data.addressLine2,
					addressLine3: data.addressLine3,
					country: data.country,
					postal: data.postal,
					latitude: data.latitude,
					longitude: data.longitude,
					sundayHours: data.sundayHours,
					mondayHours: data.mondayHours,
					tuesdayHours: data.tuesdayHours,
					wednesdayHours: data.wednesdayHours,
					thursdayHours: data.thursdayHours,
					fridayHours: data.fridayHours,
					saturdayHours: data.saturdayHours,
					unavailableDates: unavailableDatesHolder ? unavailableDatesHolder : [],
					sundayAvailability: data.sundayAvailability,
					mondayAvailability: data.mondayAvailability,
					tuesdayAvailability: data.tuesdayAvailability,
					wednesdayAvailability: data.wednesdayAvailability,
					thursdayAvailability: data.thursdayAvailability,
					fridayAvailability: data.fridayAvailability,
					saturdayAvailability: data.saturdayAvailability
				};

				global.axios.request({
					method: 'post',
					url: '/cleaners',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addCleaner', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id cleaners API
		*  Edits an existing cleaner into the server
		*  @params: Object (cleaners data)
		*  @return: Object
		*/
		editCleaner( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {

				let unavailableDatesHolder;
				if (data.unavailableDates) {
					unavailableDatesHolder = data.unavailableDates.map(item => {
                        if(moment(item.startTime).isValid()) {
                            return {
                                startTime: moment(item.startTime).format('YYYY-MM-DD HH:mm:ss'),
                                endTime: moment(item.endTime).format('YYYY-MM-DD HH:mm:ss'),
                                description: item.description
                            };
                        } else if (item.startTime.indexOf('/') != -1) {
                            return {
                                startTime: moment(item.startTime, 'DD/MM/YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
                                endTime: moment(item.endTime, 'DD/MM/YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
                                description: item.description,
								creaetdAt: item.createdAt
                            };
                        } else {
                            return {
                                startTime: moment(item.startTime, 'DD-MM-YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
                                endTime: moment(item.endTime, 'DD-MM-YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
                                description: item.description,
								creaetdAt: item.createdAt
                            };
                        }
					});
				};

				const postData = {
					salutation: data.salutation,
					firstname: data.firstname,
					lastname: data.lastname,
					profilePhoto: data.profilePhoto,
					email: data.email,
					mobile: '65' + data.mobile,
					languages: data.languages,
					addressLine1: data.addressLine1,
					addressLine2: data.addressLine2,
					addressLine3: data.addressLine3,
					country: data.country,
					postal: data.postal,
					latitude: data.latitude,
					longitude: data.longitude,
					sundayHours: data.sundayHours,
					mondayHours: data.mondayHours,
					tuesdayHours: data.tuesdayHours,
					wednesdayHours: data.wednesdayHours,
					thursdayHours: data.thursdayHours,
					fridayHours: data.fridayHours,
					saturdayHours: data.saturdayHours,
					unavailableDates: unavailableDatesHolder ? unavailableDatesHolder : [],
					sundayAvailability: data.sundayAvailability,
					mondayAvailability: data.mondayAvailability,
					tuesdayAvailability: data.tuesdayAvailability,
					wednesdayAvailability: data.wednesdayAvailability,
					thursdayAvailability: data.thursdayAvailability,
					fridayAvailability: data.fridayAvailability,
					saturdayAvailability: data.saturdayAvailability
				};

				global.axios.request({
					method: 'post',
					url: '/cleaners/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addCleaner', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id cleaners API
		*  Removes an existing cleaner into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deleteCleaner( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/cleaners/' + identifier + '/trash',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deleteCleaner', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/*
		*  /POST/signin cleaners API
		*  Requests an otp for the number
		*  @params: Object (phone number and OTP)
		*  @return: 200 OK
		*/
		sendOtpCleaner( { commit, state }, data ) {

			return new Promise ((resolve, reject) => {

				const postData = {
					mobile: '65' + data.mobile
				};

				global.axios.request({
					method: 'post',
					url: '/cleaners/signin',
					data: postData,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/*
		*  /POST/change-mobile of cleaner API
		*  Requests an otp for the new mobile number
		*  @params: Object (phone number and OTP)
		*  @return: 200 OK
		*/
		sendOtpCleanerNewMobile( { commit, state }, data ) {

			return new Promise ((resolve, reject) => {

				const postData = {
					mobile: data.mobile,
					cleanerID: data.cleanerID
				};

				global.axios.request({
					method: 'post',
					url: '/cleaners/change-mobile',
					data: postData,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/*
		*  /POST/verify OTP for new mobile of cleaner API
		*  Verify otp for the new mobile number
		*  @params: Object (OTP)
		*  @return: 200 OK
		*/
		verifyOtpCleanerNewMobile( { commit, state }, data ) {

			return new Promise ((resolve, reject) => {

				const postData = {
					otp: data.otp,
					cleanerID: data.cleanerID
				};

				global.axios.request({
					method: 'post',
					url: '/cleaners/verify-new-mobile',
					data: postData,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST/:id/untrash cleaners API
		*  Restores a cleaner into the server from the trash
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		untrashCleaner( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'post',
					url: '/cleaners/' + identifier + '/untrash',
					validateStatus: ( status ) => { return status == 200; },
				})
				.then(response => {
					const updatedList = state.cleanersList.map(item => {
						if (item.id === identifier ) {
							let holder = item;
							holder.trash = 0;
							return holder;
						} else {
							return item;
						};
					});
					commit( 'updateCleanerList', updatedList );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET cleaners API CSV
		*  Get all cleaners from the server as a CSV
		*  (different headers)
		*  @return: Array
		*/
		getCleanersCsv( { commit } ) {

			window.open( process.env.ENDPOINT + '/cleaners?download=1&from=0&size=9999999' );

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		},

		/* 
		*  /GET
		*  Get block booking
		*  @return: Object
		*/
		getBlockBooking( { commit, state } ) {

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/cleaners/list-block-booking',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST/ block booking API
		*  @return: Object
		*/
		blockBooking( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {

			    let unavailableDatesHolder = data.map(item => {
					return {
						startTime: moment(item.startTime, 'DD/MM/YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
						endTime: moment(item.endTime, 'DD/MM/YYYY - h:mm a').format('YYYY-MM-DD HH:mm:ss'),
						cleaner: item.cleanerSelect.map(cleaner => { return cleaner.id }),
						description: item.description,
						jobType: item.jobType,
						cleanerType: item.cleanerType,
					};
				});

				const postData = {
					unavailable_dates: unavailableDatesHolder
				};

				global.axios.request({
					method: 'post',
					url: '/cleaners/block-booking',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Cleaners.js